class MaterialTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-keyword]');
    this.panels = this.querySelectorAll('[data-panel]');
    this.mediaElements = this.querySelectorAll('[data-media-for]');
    this.attachTabListeners();
    if (!this.variantListenerAttached) {
      this.attachVariantListeners();
      this.variantListenerAttached = true;
    }
    this.setMinHeight();
  }

  setMinHeight() {
    const tabsContent = this.querySelector('.modal-tabs__content');
    if (!tabsContent || !this.panels.length) return;
    
    let maxHeight = 0;
    this.panels.forEach(panel => {
      panel.style.display = 'block';
      panel.style.visibility = 'hidden';
      const height = panel.offsetHeight;
      if (height > maxHeight) maxHeight = height;
      panel.style.display = '';
      panel.style.visibility = '';
    });
    
    if (maxHeight > 0) {
      this.style.setProperty('--modal-tabs-min-height', `${maxHeight}px`);
    }
  }

  handleize(str) {
    return str.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  switchTab(tabElement) {
    const tabId = this.handleize(tabElement.getAttribute('data-keyword'));
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    this.panels.forEach(panel => panel.classList.remove('active'));
    this.mediaElements.forEach(media => media.classList.remove('active'));
    tabElement.classList.add('active');
    tabElement.setAttribute('aria-selected', 'true');
    const activePanel = this.querySelector(`[data-panel="${tabId}"]`);
    if (activePanel) activePanel.classList.add('active');
    const activeMedia = this.querySelector(`[data-media-for="${tabId}"]`);
    if (activeMedia) activeMedia.classList.add('active');
  }

  attachTabListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(tab);
      });
    });
  }

  attachVariantListeners() {
    document.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && 
          (e.target.name.toLowerCase().includes('metal') || e.target.name.toLowerCase().includes('material'))) {
        const selectedValue = e.target.value.toLowerCase().trim();
        this.tabs = this.querySelectorAll('[data-keyword]');
        let matchedTab = null;
        this.tabs.forEach(tab => {
          const tabKeyword = tab.getAttribute('data-keyword')?.toLowerCase().trim();
          if (tabKeyword && selectedValue.includes(tabKeyword)) matchedTab = tab;
        });
        if (matchedTab) {
          this.panels = this.querySelectorAll('[data-panel]');
          this.mediaElements = this.querySelectorAll('[data-media-for]');
          this.switchTab(matchedTab);
        }
      }
    });
  }
}

customElements.define('material-tabs', MaterialTabs);

class ModalVideoController {
  constructor() {
    this.attachListeners();
  }

  attachListeners() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('modal-opener');
      if (opener) {
        const modalId = opener.getAttribute('data-modal');
        if (modalId) {
          const modal = document.getElementById(modalId);
          if (modal) setTimeout(() => this.handleModalOpen(modal), 100);
        }
      }
      const closeButton = e.target.closest('[data-modal-close]');
      if (closeButton) {
        const modal = closeButton.closest('modal-dialog');
        if (modal) this.handleModalClose(modal);
      }
    });
  }

  handleModalOpen(modal) {
    modal.querySelectorAll('[data-modal-media] video').forEach(video => {
      video.play().catch(() => {});
    });
    
    const materialTabs = modal.querySelector('material-tabs');
    if (materialTabs) {
      const images = materialTabs.querySelectorAll('img');
      let loadedCount = 0;
      const totalImages = images.length;
      
      if (totalImages === 0) {
        materialTabs.setMinHeight();
      } else {
        images.forEach(img => {
          if (img.complete) {
            loadedCount++;
            if (loadedCount === totalImages) {
              materialTabs.setMinHeight();
            }
          } else {
            img.addEventListener('load', () => {
              loadedCount++;
              if (loadedCount === totalImages) {
                materialTabs.setMinHeight();
              }
            }, { once: true });
          }
        });
      }
    }
  }

  handleModalClose(modal) {
    modal.querySelectorAll('[data-modal-media] video').forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new ModalVideoController());
